import script from "./TransferRowsMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferRowsMobile.vue?vue&type=script&setup=true&lang=js"

import "./TransferRowsMobile.vue?vue&type=style&index=0&id=267f39cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267f39cc"]])

export default __exports__